import { render, staticRenderFns } from "./CovidXQTL.vue?vue&type=template&id=3087f50a&"
import script from "./CovidXQTL.vue?vue&type=script&lang=js&"
export * from "./CovidXQTL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports